var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	21: () => (loadSingletonVersion("default", "react", true, [4,18,2,0], () => (() => (__webpack_require__(22))))),
	76: () => (loadSingletonVersion("default", "@chakra-ui/anatomy", true, [4,2,2,2], () => (() => (__webpack_require__(13))))),
	437: () => (loadSingletonVersion("default", "react-dom", true, [4,18,2,0], () => (() => (__webpack_require__(438))))),
	1159: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/interfaces", false, [4,0,0,1], () => (__webpack_require__.e(62).then(() => (() => (__webpack_require__(2080))))))),
	1174: () => (loadSingletonVersion("default", "react-i18next", true, [1,11,13,0], () => (() => (__webpack_require__(1079))))),
	1161: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/theme-hooks", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(39), __webpack_require__.e(71), __webpack_require__.e(63), __webpack_require__.e(76), __webpack_require__.e(31), __webpack_require__.e(46), __webpack_require__.e(51), __webpack_require__.e(53), __webpack_require__.e(37), __webpack_require__.e(56), __webpack_require__.e(36), __webpack_require__.e(27)]).then(() => (() => (__webpack_require__(2138))))))),
	1167: () => (loadSingletonVersion("default", "react-router-dom", true, [4,6,11,2], () => (() => (__webpack_require__(1140))))),
	1158: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/auth", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(39), __webpack_require__.e(46), __webpack_require__.e(51), __webpack_require__.e(37), __webpack_require__.e(50)]).then(() => (() => (__webpack_require__(1193))))))),
	1178: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/web-store", true, [4,0,0,1], () => (() => (__webpack_require__(946))))),
	1192: () => (loadSingletonVersion("default", "i18next", true, [1,20,6,1], () => (() => (__webpack_require__(1062))))),
	1188: () => (loadSingletonVersion("default", "axios", true, [1,1,6,5], () => (() => (__webpack_require__(989))))),
	1196: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/api", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(31), __webpack_require__.e(46), __webpack_require__.e(49), __webpack_require__.e(47)]).then(() => (() => (__webpack_require__(1185))))))),
	1165: () => (loadSingletonVersion("default", "react-query", true, [1,3,39,3], () => (() => (__webpack_require__(1101))))),
	1213: () => (loadSingletonVersion("default", "@chakra-ui/react", true, [4,2,8,2], () => (() => (__webpack_require__(194))))),
	1221: () => (loadSingletonVersion("default", "@shared.mfe.monorepo/route-utils", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(31), __webpack_require__.e(30), __webpack_require__.e(41)]).then(() => (() => (__webpack_require__(1170))))))),
	1220: () => (loadSingletonVersion("default", "@chakra-ui/icons", true, [4,2,1,1], () => (() => (__webpack_require__(17))))),
	1214: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/core-components", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(68), __webpack_require__.e(44), __webpack_require__.e(57), __webpack_require__.e(56), __webpack_require__.e(67)]).then(() => (() => (__webpack_require__(1912))))))),
	1218: () => (loadSingletonVersion("default", "react-device-detect", true, [1,2,1,2], () => (() => (__webpack_require__(1071))))),
	1164: () => (loadSingletonVersion("default", "react-error-boundary", true, [1,4,0,4], () => (() => (__webpack_require__(1075))))),
	1157: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/hooks", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(61), __webpack_require__.e(71), __webpack_require__.e(43), __webpack_require__.e(72), __webpack_require__.e(31), __webpack_require__.e(44), __webpack_require__.e(46), __webpack_require__.e(51), __webpack_require__.e(53), __webpack_require__.e(37), __webpack_require__.e(38), __webpack_require__.e(57), __webpack_require__.e(54), __webpack_require__.e(30), __webpack_require__.e(55), __webpack_require__.e(49), __webpack_require__.e(32), __webpack_require__.e(60), __webpack_require__.e(70), __webpack_require__.e(48)]).then(() => (() => (__webpack_require__(1951))))))),
	1160: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/store", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e(34), __webpack_require__.e(75), __webpack_require__.e(74)]).then(() => (() => (__webpack_require__(2127))))))),
	1281: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/analytics", false, [4,0,0,1], () => (__webpack_require__.e(45).then(() => (() => (__webpack_require__(1175))))))),
	1289: () => (loadSingletonVersion("default", "react-custom-events", true, [1,1,0,6], () => (() => (__webpack_require__(1069))))),
	1346: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/configurator", false, [4,0,0,1], () => (__webpack_require__.e(66).then(() => (() => (__webpack_require__(1908))))))),
	1268: () => (loadSingletonVersion("default", "react-hook-form", true, [1,7,18,0], () => (() => (__webpack_require__(1077))))),
	1162: () => (loadSingletonVersion("default", "easy-peasy", true, [1,6,0,0], () => (() => (__webpack_require__(1040))))),
	1266: () => (loadSingletonVersion("default", "react-player", false, [1,2,16,0], () => (__webpack_require__.e(78).then(() => (() => (__webpack_require__(2241))))))),
	1274: () => (loadSingletonVersion("default", "axios", true, [1,1,6,5], () => (() => (__webpack_require__(962))))),
	1334: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/form-core", false, [4,0,0,1], () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(1939))))))),
	1369: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/cms", false, [4,0,0,1], () => (__webpack_require__.e(52).then(() => (() => (__webpack_require__(1206))))))),
	1882: () => (loadSingletonVersion("default", "html-react-parser", false, [1,5,2,2], () => (__webpack_require__.e(77).then(() => (() => (__webpack_require__(2223))))))),
	2009: () => (loadSingletonVersion("default", "i18next-browser-languagedetector", true, [1,6,1,2], () => (() => (__webpack_require__(1052))))),
	2010: () => (loadSingletonVersion("default", "i18next-http-backend", true, [1,1,4,0], () => (() => (__webpack_require__(1056))))),
	1: () => (loadSingletonVersion("default", "@tailoor.mfe.monorepo/load-remote-module", true, [4,0,0,1], () => (() => (__webpack_require__(2)))))
};
var initialConsumes = [21,76,437];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"15": [
		21,
		76,
		437
	],
	"27": [
		1
	],
	"29": [
		1157
	],
	"30": [
		1158
	],
	"31": [
		1159
	],
	"32": [
		1160
	],
	"33": [
		1161
	],
	"34": [
		1162
	],
	"36": [
		1164
	],
	"37": [
		1165
	],
	"38": [
		1167
	],
	"44": [
		1174
	],
	"46": [
		1178
	],
	"47": [
		1188
	],
	"48": [
		2009,
		2010
	],
	"49": [
		1192
	],
	"51": [
		1196
	],
	"53": [
		1213
	],
	"54": [
		1214
	],
	"55": [
		1218
	],
	"56": [
		1220
	],
	"57": [
		1221
	],
	"58": [
		1266,
		1274,
		1334,
		1369,
		1882
	],
	"59": [
		1268
	],
	"60": [
		1281,
		1289,
		1346
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}